import styles from '~/styles/pages/demo.css?url'
import formStyles from '~/styles/components/form.css?url'
import gridStyles from '~/styles/components/grid.css?url'
import { H1, H2, P, Stack } from '~/components-v2'
import { getBlogPosts } from '~/services/contentful'
import { LoaderFunctionArgs } from '@remix-run/node'
import { rudderStack } from '~/utils/rudder-stack.server'
import { useTypedLoaderData } from 'remix-typedjson'
import { ReactNode } from 'react'
import { UtmFields } from '~/utils/utm-fields'
import { Blobby } from '~/components-v2/blobby/blobby'
import blobStyles from '~/components-v2/blobby/blobby.css?url'
import {
  PostCollection,
  postCollectionLinks,
} from '~/components-v2/post-collection/post-collection'

export { ErrorBoundary } from './_landing.demo'
export { meta } from '~/utils'
export const links = () => [
  { rel: 'stylesheet', href: formStyles },
  ...postCollectionLinks(),
  { rel: 'stylesheet', href: gridStyles },
  { rel: 'stylesheet', href: blobStyles },
  { rel: 'stylesheet', href: styles },
]

const title = 'Subscribe to our newsletter'
const description = 'Be omniscient'

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const { posts } = await getBlogPosts({ limit: 3 })
  rudderStack(request, title)
  return { posts, description, title }
}

export default function Component({ children }: { children?: ReactNode }) {
  const loaderData = useTypedLoaderData<typeof loader>()
  const posts = 'posts' in loaderData ? loaderData.posts : []

  const heading = (
    <>
      <H1 color="title" fontSize="xxxxl" fontWeight={600}>
        {description}
      </H1>
      <H2 fontSize="xxl" color="text2">
        {title}
      </H2>
    </>
  )

  return (
    <Stack gap={8} align="center">
      <div className="subscribe-page-content">
        <Stack gap={3} shrink={1} as="article" className="content">
          <Stack row justify="space-between" align="center" as="hgroup" gap={6}>
            <Stack gap={2}>{heading}</Stack>
            <Blobby
              color={'dawn'}
              expression={'happy'}
              style={{ '--blob-size': '80px', marginTop: '-30px' }}
            />
          </Stack>

          <P fontSize="md">
            Get advice on building your data strategy, community updates, and —
            because it’s our newsletter — the latest Omni product updates
            delivered right to your inbox.
          </P>
          <P fontSize="md">
            PS — We use AI in our product, not our content. Don’t worry.
          </P>
        </Stack>
        <Stack as="article" className="form form-narrow" justify="center">
          <Stack gap={4}>
            <Stack className="mobile-title">
              <Stack row as="hgroup" gap={2}>
                <Stack gap={1} grow={1}>
                  <H1
                    color="title"
                    lineHeight={1.15}
                    fontWeight={800}
                    fontSize="xxxl"
                  >
                    {title}
                  </H1>
                  <H2 fontSize="xl" lineHeight={1.5} color="text2">
                    {description}
                  </H2>
                </Stack>
                <Blobby
                  color={'dawn'}
                  expression={'happy'}
                  style={{ '--blob-size': '80px', marginTop: '-10px' }}
                />
              </Stack>
            </Stack>
            {children}
            <form
              method="POST"
              action="https://exploreomni.activehosted.com/proc.php"
            >
              <input type="hidden" name="u" value="23" />
              <input type="hidden" name="f" value="23" />
              <input type="hidden" name="s" />
              <input type="hidden" name="c" value="0" />
              <input type="hidden" name="m" value="0" />
              <input type="hidden" name="act" value="sub" />
              <input type="hidden" name="v" value="2" />
              <input
                type="hidden"
                name="or"
                value="c1a3e4930de83495e440762947bae0a2"
              />
              <UtmFields />
              <div className="field">
                <label htmlFor="email">
                  Email <span className="required">*</span>
                </label>
                <input type="email" name="email" size={32} required />
              </div>
              <button type="submit">Subscribe</button>
            </form>
          </Stack>
        </Stack>
      </div>
      <section className="demo-secondary-content">
        <PostCollection posts={posts} />
      </section>
    </Stack>
  )
}
